import { Field, Form, Formik } from "formik";
import React, { useEffect } from "react";
import { AEAutoComplete } from "../../../../../../_metronic/_partials/controls";
import { geDepositStatusClassName } from "../../../helpers/StatusHelpers";

const EditForm = ({ entity, btnRef, saveEntity, validationErrors }) => {
  // console.log({ entity });
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{ ...entity }}
        initialErrors={validationErrors}
        onSubmit={(values) => {
          // console.log({ values });
          saveEntity(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form className="form form-label-right m-auto">
            {!!entity.id && (
              <>
                <div class="form-group row">
                  <label
                    hmtlFor=""
                    className="badge badge-secondary text-white mr-5"
                  >
                    Status
                  </label>

                  <p className={geDepositStatusClassName(entity.status)}>
                    {entity.status}
                  </p>
                </div>
                <div class="form-group row">
                  <label
                    hmtlFor=""
                    className="badge badge-secondary text-white mr-5"
                  >
                    User
                  </label>

                  <p>{entity.user.commercial_name}</p>
                </div>

                <div class="form-group row">
                  <label
                    hmtlFor=""
                    className="badge badge-secondary text-white mr-5"
                  >
                    Receipt Number
                  </label>

                  <p className="form-control-static">{entity.receipt_number}</p>
                </div>
                <div class="form-group row">
                  <label
                    hmtlFor=""
                    className="badge badge-secondary text-white mr-5"
                  >
                    Change Status
                  </label>
                  <div className="col-lg-3">
                    <Field
                      name={`status`}
                      component={AEAutoComplete}
                      label={`Status`}
                      options={[
                        // { label: "Pending", id: "Pending" },
                        // { label: "Success", id: "Success" },
                        // { label: "Canceled", id: "Canceled" },
                        "Pending",
                        "Success",
                        "Canceled",
                      ]}
                      // getOptionLabel={(o) => o.label}
                      // useId
                      withFeedbackLabel={false}
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  style={{ display: "none" }}
                  ref={btnRef}
                  onSubmit={handleSubmit}
                />
              </>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default EditForm;
